import { Component, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Platform, ModalController, ActionSheetController,  NavController, LoadingController, ToastController, Config } from '@ionic/angular';
import { Subscription, Subject, Observer } from 'rxjs';
import { timer } from 'rxjs';
import { LocationProvider } from '../location-handler';
import { EventDetailsModel, EventProvider, NearbyEventNew } from '../../providers/event/event';
import { ResultProvider, StatisticsResults } from '../../providers/result/result';
// import { TrackingSettingsPage } from '../../pages/tracking-settings/tracking-settings';
import { StepDetector } from '../step-detector';
import { DeviceMotion, DeviceMotionAccelerationData } from '@awesome-cordova-plugins/device-motion/ngx';;
import { GpsTracker } from '../gps-tracker';
import { AudioSystemProvider } from '../../providers/audio-system/audio-system';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { RouteMarathon, StrackerProvider, TrackerModel } from '../../providers/stracker/stracker';
import { SessionProvider } from '../../providers/session/session';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { StepController } from '../step-controller';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { ConfigProvider } from '../../providers/config/config';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { AutoPause, ObserverGeneral, SubjectGeneral } from '../autopause/autopause';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { IconPipe } from '../../pipes/icon/icon';
import { StrackerUtils } from '../sencha-tracker/stracker-utils';
import { LocationHandlerUtil } from '../location-handler-utils';
import { NewsController } from '../../providers/news/news-contoller';
import { CountdownBg, CountdownComponent } from '../../components/show-modal/show-modal';
import { RunStatistics } from '../run-statistics/run-statistics';
import { RequestProvider } from '../../providers/request/request';
import { ScoreBoardModal } from '../../components/score-board-modal/score-board-modal';
import { ScoreBoardEinzel } from '../../components/score-board-einzel/score-board-einzel';
import { ScoreBoardWallen } from '../../components/score-board-wallen/score-board-wallen';
import { Router } from '@angular/router';
import { TrackingSettingsPage } from 'src/pages/tracking-settings/tracking-settings';
import { environment } from 'src/environments/environment';

// interface Event {
//     id: number,
//     cid:number,
//     date:number,
//     name: string,
//     enaOrig: string,
//     plz: string,
//     place: string,
//     streckeconv: string,
//     wertung: string,
//     lat: number,
//     lng: number,
//     evtStat: string,
//     endDate: number,
//     image: string
// }

declare var google;

@Component({
    selector: 'leader-track',
    templateUrl: 'leader-track.html',
})
export class LeaderTrack implements ObserverGeneral {
    @ViewChild('map') mapElement: ElementRef;
    map: any;

    @ViewChild('bib') bibElement: ElementRef;
    locater: LocationProvider;
    clock = null;
    state: boolean = false;
    modal = null;
    activityType: number = -1;
    paused: boolean = false;
    localConfig = null;
    started = false;
    startedWave = false;
    event: any;
    stepDetector: StepDetector = null;
    steps = 0;
    data: TrackerModel = null;
    hasDistance: boolean = false;
    leader_events: EventDetailsModel[] = [];
    events: any = [];
    eventNames: any = [];
    activeEvent: any;
    wellenStartArray = [];
    rangListArray = [];
    athletesArray: any = [];
    massenstartAthletesArray: any = [];
    einelstartAthletesArray: any = [];
    finishedAthletesArray: any = [];
    selectedSegmentButton: string;
    activeIndex = 0;
    scoreBoardArray = [];

    startedAthletes: any = [];
    stopedAthletes: any = [];
    restartedAthletes: any = [];

    stepController: StepController = new StepController();

    option = {
        applause: false,
        autoPause: false,
        placement: false,
        google: false
    }

    controllerScope: boolean;
    reachedSub: Subject<boolean> = new Subject();
    reachedStartingPointSub: Subject<boolean> = new Subject();
    stepIncreaseSub: Subject<any> = new Subject();

    raceFinished: boolean = false;
    racePaused: boolean = false;
    actionPresented: boolean = false;
    viewClose: Promise<any> = null;

    lastSumDistanceForBG: number = 0;
    lastSteps: number = 0;

    viewResolver = null;

    imageLink = null;
    isMap: boolean = false;
    dataSent = false;
    iconTitle: string = "assets/imgs/sportart_svg/laufen.svg";

    view = {
        average_pace: "0",
        average_speed: "0.0"
    }

    updateView: Subscription = null;
    token: string = "";
    appName: string = "";

    testMode: boolean = false;

    // UI elements
    showheader: boolean = true;
    hideheader: boolean = false;
    settingsButton: boolean = false;
    isStopPressed: boolean = false;
    isPlayDisabled: boolean = false;
    isPlayDisabledW1: boolean = true;
    isPlayDisabledW2: boolean = true;
    isPlayDisabledW3: boolean = true;
    isPlayDisabledW4: boolean = true;
    isPlayDisabledW5: boolean = true;
    isPlayDisabledW6: boolean = true;
    isPlayDisabledW7: boolean = true;
    isPlayDisabledW8: boolean = true;
    isPlayDisabledW9: boolean = true;

    stopAllowed: boolean = false;
    warningMessage: boolean = false;
    wave1NotStarted: boolean = true;
    wave2NotStarted: boolean = true;
    wave3NotStarted: boolean = true;
    wave4NotStarted: boolean = true;
    wave5NotStarted: boolean = true;
    wave6NotStarted: boolean = true;
    wave7NotStarted: boolean = true;
    wave8NotStarted: boolean = true;
    wave9NotStarted: boolean = true;

    raceByName: boolean = true;
    raceByBib: boolean = false;
    leaderActivity: boolean = false;

    color: string = "black";
    colorIcon: string = "black";
    bgColor: string = "white";
    types: any;

    mode: any = {
        id: 16,
        name: "Laufen",
        uniqueName: "RunEnduranceTraining"
    };

    allowCountdown: boolean = true;

    route: RouteMarathon = {
        hasRoute: false,
        fullPath: []
    };
    tapsObj = {};
    runStatistics: RunStatistics;
    routerState:any;

    constructor(
        public platform: Platform,
        public request: RequestProvider,
        private resultService: ResultProvider,
        private modalCtrl: ModalController,
        private deviceMotion: DeviceMotion,
        private audioService: AudioSystemProvider,
        private actionSheetCtrl: ActionSheetController,
        private translate: TranslateService,
        private router:Router,
        private loadingCtrl: LoadingController,
        private storage: Storage,
        private strackerService: StrackerProvider,
        private sessionService: SessionProvider,
        private device: Device,
        private diagnostic: Diagnostic,
        private config: ConfigProvider,
        private storageService: StorageProvider,
        private zone: NgZone,
        private toastCtrl: ToastController,
        private appDetector: AppDetectorProvider,
        private icons: IconPipe,
        private eventService: EventProvider,
        private navCtrl: NavController) {
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};

        this.getLeaderEvents();

        console.log('LeaderTrackPage has loaded…');
        if (!this.sessionService.isLoged) return;

        this.selectedSegmentButton = "massenstart"

        this.route = this.routerState["route"];
        this.imageLink = this.routerState["imageLink"];
        console.log('constuctor()');

        this.viewClose = new Promise<any>((resolve, reject) => {
            this.viewResolver = resolve;
        });

        this.preloadUI();

        this.initialize();

        this.locater = new LocationProvider( this.map, this.reachedSub, this.event, this.zone, this.toastCtrl, this.platform, this.reachedStartingPointSub, this.storageService, this.appDetector, this.option.google);
       
        this.runStatistics = new RunStatistics({ localDb: this.storageService, locater: this.locater, event: this.eventService }, this.event);

        if (this.sessionService.isLoged) {
            const userId = this.sessionService.profile.id;

            this.runStatistics.writeUserId(userId);

            this.strackerService.getResultPreload((typeof this.event === "undefined") ? -1 : this.event.eventId, userId + "").then((data: TrackerModel) => {

                this.data = data;

                console.log('load from constructor');
                this.runStatistics.load();
                this.initPreload();
            });
        }

        AutoPause.getInstance().attach(this);

        this.preloadSettings();

        this.updateView = timer(0, 5000).subscribe(() => {
            if ((this.appDetector.isHellaApp() || this.appDetector.isForestApp() || this.appDetector.isThurnauApp()) && this.started)
                this.runStatistics.writeRoutePoints();

            this.getCurrentSpeed();
            this.getAverageSpeed();
        });
    }

    isStartedArrayEmty() {
        let res;
        if (typeof this.startedAthletes[0] === "undefined") {
            res = true;
        }
        else {
            res = false;
        }
        return res;
    }

    isStopedArrayEmpty() {
        let res;
        if (typeof this.stopedAthletes[0] === "undefined") {
            res = true;
        }
        else {
            res = false;
        }
        return res;
    }

    isRestartedArrayEmpty() {
        let res;
        if (typeof this.restartedAthletes[0] === "undefined") {
            res = true;
        }
        else {
            res = false;
        }
        return res;
    }

    isAthleteStarted(ath) {
        let startedArrayEmpty = this.isStartedArrayEmty();
        if (!startedArrayEmpty) {
            let returnResult: boolean;

            console.log("started athelete 0  " + this.startedAthletes[0]);
            for (let i = 0; i < this.startedAthletes.length; i++) {

                if (this.startedAthletes[i].lastName == ath.lastName) {
                    returnResult = true;
                    break;
                }
                else {
                    returnResult = false;
                }
            }
            console.log("return res started " + returnResult);
            return returnResult;
        }
        else {
            return false;
        }

    }

    isAthleteStoped(ath) {
        let stopedArrayEmpty = this.isStopedArrayEmpty();
        if (!stopedArrayEmpty) {
            let returnResult;

            for (let i = 0; i < this.stopedAthletes.length; i++) {
                if (this.stopedAthletes[i].lastName == ath.lastName) {
                    returnResult = true;
                    break;
                }
                else {
                    returnResult = false;
                }
            }
            console.log("return res stoped " + returnResult);
            return returnResult;
        }
        else {
            return false;
        }
    }

    isAthleteRestarted(ath) {
        let restartedArrayEmpty = this.isRestartedArrayEmpty();
        if (!restartedArrayEmpty) {
            let returnResult;
            for (let i = 0; i < this.restartedAthletes.length; i++) {
                if (this.restartedAthletes[i].lastName == ath.lastName) {
                    returnResult = true;
                    break;
                }
                else {
                    returnResult = false;
                }
            }
            console.log("return res restarted " + returnResult);
            return returnResult;
        }
        else {
            return false;
        }
    }

    deleteAthlete(ath, array) {
        array.splice(array.findIndex(i => i.lastName == ath.lastName), 1);
    }

    displayAthleteTimer(ath) {
        return (ath.startTime && ath.stopTime) ? + ath.stopTime - +ath.startTime : 0;
    }


    athleteTimer(ath) {
        if (ath.active) {
            ath.stopTime = new Date;
            setTimeout(() => {
                this.athleteTimer(ath)
            }, 1000);
        }
    }

    startTimer(ath) {
        ath.startTime = new Date();
        ath.stopTime = ath.stopTime;
        ath.active = true;
        this.athleteTimer(ath);
    }

    stopTimer(ath) {
        ath.stopTime = new Date();
        ath.active = false;
    }

    restartTimer(ath) {
        ath.startTime = 0;
        ath.stopTime = 0;
        ath.active = false;
    }


    displayWaveTimer(array, selectedWave) {
        let i = array.findIndex(i => i.groupId == selectedWave);
        if (i >= 0) {
            return this.transform(array[i].time);
        }
        else {
            return this.transform(0);
        }
    }

    userClickWallen(athlete) {
        athlete.groupId = this.selectedSegmentButton;
        athlete.isSelected = true;
        this.isPlayDisabledW1 = false;
        console.log("athletes " + JSON.stringify(this.athletesArray));
        console.log("selected segment button " + this.selectedSegmentButton);
    }

    startWaveTimer(array, selectedWave) {
        if (selectedWave == "wellenstart1") {
            this.wave1NotStarted = false;
        }
        for (let i = 0; i < array.length; i++) {
            if (array[i].groupId == selectedWave) {
                array[i].interval = setInterval(() => {
                    if (array[i].time === 0) {
                        array[i].time++;
                    }
                    else {
                        array[i].time++;
                    }
                    array[i].totalTime = this.transform(array[i].time);
                }, 1000);
                array[i].waveStarted = true;
            }
        }

        console.log("selected wave: " + this.selectedSegmentButton);
        console.log("wave start: " + JSON.stringify(array));
    }

    pauseWaveTimer(array, selectedWave) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].groupId == selectedWave) {
                array[i].waveStarted = false;
                clearInterval(array[i].interval);
            }
        }

        console.log("wave pause: " + JSON.stringify(array));
    }

    restartWaveTimer(array, selectedWave) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].groupId == selectedWave) {
                array[i].totalTime = this.transform(0);
                array[i].time = 0;
                array[i].waveStarted = false;
                clearInterval(array[i].interval);
            }
        }

        this.pauseWaveTimer(array, selectedWave);
    }

    transform(value: number): string {
        var sec_num = value;
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num % 60;

        if (minutes > 60) {
            hours++;
        };
        if (seconds > 60) {
            minutes++;
        };

        if (hours < 10 && minutes < 10 && seconds < 10) {
            return '0' + hours + ':' + '0' + minutes + ':' + '0' + seconds;
        }
        else if (hours < 10 && minutes < 10) {
            return '0' + hours + ':' + '0' + minutes + ':' + seconds;
        }
        else if (hours < 10) {
            return '0' + hours + ':' + minutes + ':' + seconds;
        }
        const pad = (num: number): string => (num < 10 ? '0' + num : '' + num)
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    getWaveStartedValue(array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].isSelected == true && array[i].groupId == this.selectedSegmentButton) {
                return array[i].waveStarted;
                break
            }
        }
    }

    isPlayButtonDisabled(array, selectedWave) {
        let result: boolean;
        for (let i = 0; i < array.length; i++) {
            if (array[i].isSelected == true && array[i].groupId == selectedWave) {
                result = false;
                break;
            }
            else {
                result = true;
            }
        }
        return result;
    }

    onUserClick(ath) {
        let userExistInStarted = this.isAthleteStarted(ath);
        let userExistInStoped = this.isAthleteStoped(ath);
        let userExistInRestarted = this.isAthleteRestarted(ath);

        if (userExistInStarted == false && userExistInStoped == false && userExistInRestarted == false) {
            this.startedAthletes.push(ath);
            this.startTimer(ath);
            console.log("section1");
        }
        if (userExistInStarted == true && userExistInStoped == false && userExistInRestarted == false) {
            this.stopedAthletes.push(ath);
            this.deleteAthlete(ath, this.startedAthletes);
            this.stopTimer(ath);
            console.log("section2");
        }
        if (userExistInStarted == false && userExistInStoped == true && userExistInRestarted == false) {
            this.restartedAthletes.push(ath);
            this.restartTimer(ath);
            this.deleteAthlete(ath, this.stopedAthletes);
            console.log("section3");
        }
        if (userExistInStarted == false && userExistInStoped == false && userExistInRestarted == true) {
            this.startedAthletes.push(ath);
            this.startTimer(ath);
            this.deleteAthlete(ath, this.restartedAthletes);
            console.log("section4");
        }
    }

    async eventNameChange($event) {
        if ($event == "Rennen nach Namen") {
            this.raceByName = true;
            this.leaderActivity = false;
            this.raceByBib = false;
        }

        else if ($event == "Rennen nach Startnummer") {
            this.raceByBib = true;
            this.raceByName = false;
            this.leaderActivity = false;
        }

        else {
            this.raceByBib = false;
            this.raceByName = false;
            this.leaderActivity = true;

            let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
            loader.present();

            this.athletesArray.length = 0;
            this.einelstartAthletesArray.length = 0;
            this.scoreBoardArray.length = 0;

            this.storageService.saveData(this.scoreBoardArray, 'score-board').then(() => {
                console.log("old scoreboard deleted! " + this.scoreBoardArray);
            });

            let searchModel = { eid: '' + $event.id, ename: '' + $event.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };
            this.resultService.getRangList(searchModel).then(async data => {
                this.rangListArray = Object.assign([], data);

                if (this.rangListArray.length !== 0) {
                    this.athletesArray.length = 0;
                    this.finishedAthletesArray.length = 0;
                    let eventId = this.rangListArray[0].eventId;

                    let url = `${environment.sporteventApi}event/${eventId}/registrations`;
                    this.request.get(url).toPromise().then(data => {

                        this.massenstartAthletesArray = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < this.massenstartAthletesArray.length; i++) {
                            this.massenstartAthletesArray[i].isPaused = true;
                            this.massenstartAthletesArray[i].isStoped = false;
                        }

                        this.einelstartAthletesArray = JSON.parse(JSON.stringify(data));

                        for (let i = 0; i < this.einelstartAthletesArray.length; i++) {
                            this.einelstartAthletesArray[i].time = 0;
                            this.einelstartAthletesArray[i].active = false;
                            this.einelstartAthletesArray[i].isPaused = true;
                            this.einelstartAthletesArray[i].isRestarted = true;
                            this.einelstartAthletesArray[i].einzelTimerRunned = false;
                        }

                        this.athletesArray = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < this.athletesArray.length; i++) {
                            this.athletesArray[i].userId = i;
                            this.athletesArray[i].isSelected = false;
                            this.athletesArray[i].groupId = "";
                            this.athletesArray[i].waveStarted = false;
                            this.athletesArray[i].isPaused = true;
                            this.athletesArray[i].isTimerStarted = false;
                            this.athletesArray[i].time = 0;
                            this.athletesArray[i].isPausedTap = false;

                        }

                        console.log("this.bibNumbersArray out 1 " + JSON.stringify(this.athletesArray));
                        loader.dismiss();
                    });
                }

            });
        }
    }

    getAthleteDuration(athlete) {
        athlete.duration = this.getCurrentDuration();
        console.log(athlete);
        this.scoreBoardArray.push(athlete);
        console.log(this.scoreBoardArray);
        console.log(this.getCurrentDuration());
        this.storageService.saveData(this.scoreBoardArray, 'score-board').then(() => {
            console.log("scoreboard saved! " + this.scoreBoardArray);
        });
    }

    userTap(athlete) {
        let userExist = this.isUserExist(athlete);
        let userExistInNotFinished = this.isUserExistInNotFinished(athlete);

        if (userExist) {
            this.removeUser(athlete);
        }
        else {
            this.addUser(athlete);
        }

        if (userExistInNotFinished) {
            this.finishedAthletesArray.push(athlete);
            this.massenstartAthletesArray.splice(this.massenstartAthletesArray.findIndex(i => i.lastName == athlete.lastName), 1);
        }
        else {
            this.massenstartAthletesArray.push(athlete);
            this.finishedAthletesArray.splice(this.finishedAthletesArray.findIndex(i => i.lastName == athlete.lastName), 1);
        }

        this.checkEmptyAthletesArr();
        this.sortFinishedAthletesArr();
    }


    checkEmptyAthletesArr() {
        if (this.massenstartAthletesArray.length == 0) {
            this.openScoreBoardMassenstart();
        }
    }

    sortFinishedAthletesArr() {
        this.finishedAthletesArray.sort((a, b) => a.bibNo > b.bibNo && 1 || -1);
        console.log("finished athletes sorted " + JSON.stringify(this.finishedAthletesArray));
    }

    isUserExistInNotFinished(athlete) {
        let returnResult;
        for (let i = 0; i < this.massenstartAthletesArray.length; i++) {
            if (this.massenstartAthletesArray[i].lastName == athlete.lastName) {
                returnResult = true;
                break;
            }
            else {
                returnResult = false;
            }
        }
        return returnResult;
    }

    isUserExist(athlete) {
        let returnResult: boolean;
        for (let i = 0; i < this.scoreBoardArray.length; i++) {
            if (this.scoreBoardArray[i].lastName == athlete.lastName) {
                returnResult = true;
                break;
            }
            else {
                returnResult = false;
            }
        }
        return returnResult;
    }

    removeUser(athlete) {
        this.scoreBoardArray.splice(this.scoreBoardArray.findIndex(i => i.lastName == athlete.lastName), 1);
        this.storageService.saveData(this.scoreBoardArray, 'score-board').then(() => {
            console.log("scoreboard resaved! " + this.scoreBoardArray);
        });
    }

    addUser(athlete) {
        athlete.duration = this.getCurrentDuration();
        this.scoreBoardArray.push(athlete);
        this.storageService.saveData(this.scoreBoardArray, 'score-board').then(() => {
            console.log("scoreboard saved! " + this.scoreBoardArray);
        });
    }

    async openScoreBoardMassenstart() {
        const modal = await this.modalCtrl.create({component:ScoreBoardModal});
        modal.present();
    }

    async openScoreBoardEinzelstart(array) {
        const modal2 = await this.modalCtrl.create({component:ScoreBoardEinzel, componentProps:{ array: array }});
        modal2.present();
    }

    async openScoreBoardWallen(array) {
        let scoreBoard = array.filter(i => i.groupId == this.selectedSegmentButton);
        const modal1 = await this.modalCtrl.create({component:ScoreBoardWallen, componentProps:{ array: scoreBoard }});
        modal1.present();
    }

    getSelectedSegmentButton($event) {
        this.selectedSegmentButton = $event;
        console.log("got selected segment button " + this.selectedSegmentButton);
    }

    getScoreBoardData($event) {
        this.scoreBoardArray = $event;
        console.log("DATA FROM CHILD COMP" + JSON.stringify($event));
        console.log("SCOREBOARD ARR" + JSON.stringify(this.scoreBoardArray));
    }

    initialize() {
        this.event = {
            eventId: -1,
            eventName: "aufzeichnen-run"
        };

        // Global variable, used to check if the news can be updated
        GpsTracker.isRunning = true;

        // Thurnau app has the endless distance
        this.hasDistance = false;
        this.stopAllowed = true;
        this.resultService.getEndurances().then(async result => {
            this.types = result;
            await this.strackerService.getSaved("track-mode").then((mode) => {
                if (mode) this.mode = mode;
            })
            let type = this.types.find(e => e.name === this.mode.name);
            this.runStatistics.writeEventCid(type.id);
            this.event.cid = type.id;
        });
    }

    getLeaderEvents() {
        let getClientEvents = 'uevts';
        this.eventService.getClientEvents().then(events => {
            this.events = events;
        });
        console.log(this.events);
    }

    ionViewDidEnter($event) {
        if (this.sessionService.isLoged) {
            this.firstStart();
            this.getEvents();
        }
    }

    getActiveIndex(i) {
        if (i === this.activeIndex) {
            // console.log("index" + i);
            return true;
        }
        else {
            return false;
        }
    }

    update(subject: SubjectGeneral): void {
        if (subject instanceof AutoPause) {
            this.stopTrack(false);
        }
    }

    preloadSettings() {
        this.storageService.checkForExistance('autopause').then((status) => {
            if (status) this.storageService.getSaved('autopause').then((data) => this.option.autoPause = data);
        });

        this.storageService.checkForExistance('applause').then((status) => {
            if (status) this.storageService.getSaved('applause').then((data) => this.option.applause = data);
        });

        this.storageService.checkForExistance('placement').then((status) => {
            if (status) this.storageService.getSaved('placement').then((data) => this.option.placement = data);
        });

        if (!this.event) return;

        this.storageService.checkForExistance('stop-button-' + this.event.id + "-" + this.token).then((status) => {
            if (status) this.strackerService.getSaved('stop-button-' + this.event.id + "-" + this.token).then((data) => this.isStopPressed = data);
        });
    }

    changeMode() {
        console.log('this.mode.toLocaleLowerCase(): ', this.mode.name.toLocaleLowerCase());
        this.iconTitle = "assets/imgs/sportart_svg/" + this.converted(this.mode.name.toLocaleLowerCase()) + ".svg";
        let type = this.types.find(e => e.name === this.mode.name);
        this.mode = type;
        console.log('this.mode: ' + JSON.stringify(this.mode));
        this.strackerService.saveData(this.mode, "track-mode");
        this.event.cid = type.id;
    }

    converted(mode: string) {
        let result = mode;
        if (mode.includes("inline")) {
            result = "inlineskating";
        } else if (mode.includes("indoor")) {
            result = "indoorbicycle";
        }
        return result;
    }

    async changeModeEvent() {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        NewsController.getInstance().isAllowed = false;

        console.log('this.activeEvent: ' + this.activeEvent);

        let event = this.events.find((e) => e.name === this.activeEvent);
        console.log('event: ', event);

        this.eventService.getEventDetails(event.id).then((event) => {

            if (event.name.length < 1) {
                this.changeModeEvent();
                loader.dismiss();
            } else {
                this.navCtrl.navigateForward('/events-tabs',{state:{event}}).then(() => loader.dismiss());
                // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
            }
        }).catch(err => loader.dismiss());

    }

    locationPermission(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(null);
        });
    }

    permissionRequest(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storageService.create().then(()=>{
                this.storageService._storage.keys().then((data) => {
                    let table = data.includes("ios-perm-check-" + this.appName);
                    if (table) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }

                })
            })
        });
    }

    permissionWrite(): Promise<any> {
        return this.strackerService.saveData(true, ("ios-perm-check-" + this.appName));
    }

    onResultsRedirect() {
        this.sendData();

        // if (this.isHella) {
        //     console.log('this.imageLink: ', this.imageLink);
        //     (this.app.getRootNav() as NavController).push(ResultDescriptionPage, { statisticsResults: this.statisticsResults, registration: this.imageLink });
        // } else {
        //     this.userService.getMyResults().then(results => {
        //         (this.app.getRootNav() as NavController).push(MysportResultsPage, { results: results });
        //     });
        // }
    }

    initPreload() {
        if (this.data) {
            console.log('this.data: ', this.data);
            GpsTracker.sumDistance = this.data.distance;
            this.getLocater().setCurrentDuration(this.data.time);
            // GpsTracker.currentSpeed = (this.getLocater().getCurrentDuration() / (GpsTracker.sumDistance / 1000)); // pace
            GpsTracker.currentSpeed = LocationHandlerUtil.calcPace(GpsTracker.sumDistance, this.getLocater().getCurrentDuration());
            this.view.average_pace = this.data.average_pace;
            console.log('this.view.average_pace: ' + this.view.average_pace);
            this.view.average_speed = this.data.average_speed + "";
            console.log('this.view.average_speed: ' + this.view.average_speed);
            this.raceFinished = this.data.finished;
        }
    }

    triggerPauseResume() {
        this.platform.ready().then(() => {

            if (this.platform.is('cordova')) {

                //Subscribe on pause i.e. background
                this.platform.pause.subscribe(() => {
                    GpsTracker.isBackground = true;
                    this.lastSumDistanceForBG = GpsTracker.sumDistance;
                    this.lastSteps = this.stepDetector.stepCount;
                    this.saveData(false);
                });

                //Subscribe on resume i.e. foreground 
                this.platform.resume.subscribe(() => {

                    //Calculate the steps in background mode
                    GpsTracker.isBackground = false;

                    this.locater.setCurrentTime();

                    console.log("Hello Resume");

                    this.calculateBgSteps();

                    this.invokeMenu();

                    // this.getPermission();
                });
            }
        });
    }

    ionViewWillLeave() {
        if (!this.sessionService.isLoged) return;
        console.log('ionViewWillLeave()')
        this.stopTrack(false);
        this.saveData(false);

        if (this.stepCountSub) {
            this.stepCountSub.unsubscribe();
            this.stepCountSub = null;
        }

        this.getLocater().DISTANCE_TO_WIN = null;
        GpsTracker.isRunning = false;
    }

    saveData(finished) {
        console.log('saveData: ');
        if (finished) {
            this.strackerService.writeDataFinished(this.prepareSaveData()).then(() => {
                console.log("data finished saved!");
            });

            this.storageService.saveData(this.mode, 'track-mode').then(() => {
                console.log("sport type saved! " + this.mode);
            });
        } else {
            this.strackerService.pushDataNotFinished(this.prepareSaveData()).then(() => {
                console.log("data not finished saved!");
            });
        }
    }

    prepareSaveData() {
        let obj: TrackerModel = {
            eventId: (this.event) ? this.event.eventId : -1,
            token: this.token + "",
            time: this.getLocater().getCurrentDuration(),
            distance: GpsTracker.sumDistance,
            finished: this.raceFinished,
            average_pace: this.getCurrentSpeed(),
            average_speed: this.getAverageSpeed()
        }
        return obj;
    }

    getMapPath() {
        return this.getLocater().getMapPath();
    }

    invokeMenu() {
        if (this.raceFinished && !this.actionPresented && (GpsTracker.sumDistance >= this.getLocater().DISTANCE_TO_WIN)) {
            this.viewResolver();
            this.raceFinished = true;

            this.actionPresented = true;

            this.saveData(true);

            this.strackerService.remove();

            this.sendData();
        }
    }

    async presentActionSheet() {
        const actionSheet = await this.actionSheetCtrl.create({
            header: this.translate.instant('RACE_FINISHED'),
            buttons: [
                {
                    text: 'OK',
                    role: 'destructive',
                    handler: () => {
                        this.openResults();
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                }
            ]
        });
        actionSheet.present();
        this.actionPresented = true;
    }

    onTest() {
        this.warningMessage = false;
    }

    async openResults(timeout?: number) {
        let loader = await this.loadingCtrl.create({
            message: this.translate.instant('GLOBAL_LOADING')
        });
        loader.present();

        if (navigator.onLine) {

            loader.dismiss();
            console.log('this.runStatistics.getWrappedStatistics: ' + JSON.stringify(this.runStatistics.getWrappedStatistics()));
            this.navCtrl.navigateForward('/result-description', {state:{statisticsResults: this.runStatistics.getWrappedStatistics(), registration: this.imageLink}});
            // this.navCtrl.push(ResultDescriptionPage, { statisticsResults: this.runStatistics.getWrappedStatistics(), registration: this.imageLink });
        } else {
            loader.dismiss();
        }
    }

    calculateBgSteps() {
        if (this.lastSteps != 0) {

            let average = Math.round(this.lastSumDistanceForBG / this.lastSteps);
            let diff = Math.round(GpsTracker.sumDistance - this.lastSumDistanceForBG);

            this.stepDetector.stepCount += (diff * average);
        }
    }

    getEvents() {
        this.eventService.getClientEvents().then((events) => {
            this.events = Object.assign([], events);
            console.log('events: ' + events);

            this.eventNames = [...new Set(this.events.map((e) => e.name))];

            this.activeEvent = this.eventNames[0];

            console.log(this.eventNames);
        });
    }

    async preloadUI() {
        this.color = (await this.config.config).theme.color;
        this.colorIcon = (await this.config.config).theme.color;
        this.appName = (await this.config.config).appId;

        if (this.appDetector.isHellaApp()) {
            this.color = this.colorIcon = "white";
            this.bgColor = "#002f5d";
        } else if (this.appDetector.isEventsApp()) {
            this.color = this.colorIcon = "black";
            this.bgColor = "white";
        } else if (this.appDetector.isThurnauApp()) {
            this.color = "black";
        }
    }

    async getPermission() {
        console.log('os version: ' + this.device.version);
        if (this.platform.is('ios')) {
            console.log('this.platform.is: ' + this.platform.is('ios'));
            this.permissionRequest().then((check) => {
                console.log('this.getLocater().authStatus' + this.getLocater().authStatus);
                if (!check || this.getLocater().authStatus !== 1) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("ios");
                    });
                }
            });
        } else if (this.platform.is('android') && (this.device.version.includes("11"))) {
            this.permissionRequest().then((check) => {
                if (!check) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("android");
                    });
                }
            });
        }
    }

    goPermissionPage(OS: string) {
        this.navCtrl.navigateForward('/permission-page', {state:{os:OS}});
        // (this.app.getRootNav() as NavController).push(PermissionPage, { os: OS });
    }

    saveStatistics() {
        this.runStatistics.add().then(() => {
            this.runStatistics.save();
        });
    }

    firstStart() {
        this.platform.ready().then(() => {

            this.initSubscription();

            this.getLocater().placementEnabled = this.option.placement;

            this.stepDetector = new StepDetector(this.stepIncreaseSub);

            this.initPreload();

            this.triggerPauseResume();

            this.stepIncreaseSub.subscribe(() => {
                this.getLocater().setLastStep(new Date().getTime());
            });
        });

    }

    initSubscription() {
        try {
            this.reachedSub.subscribe((final) => {
                if (!this.raceFinished)
                    if (this.appDetector.isHellaApp() || this.appDetector.isForestApp()) {
                        console.log('saveStatistics from subscribtion')
                        this.saveStatistics();
                    }
                if (!this.raceFinished)
                    if (final) {
                        this.raceFinished = true;
                        this.distanceReached();
                    } else if (!final) {
                        this.audioService.playAudio(GpsTracker.isBackground, false, this.option.applause);
                    }
            });

            this.reachedStartingPointSub.subscribe((status) => {
                if (!this.raceFinished)
                    if (status && this.route.hasRoute) {
                        this.isPlayDisabled = false;
                        this.warningMessage = false;
                    }
            });
        } catch (err) {
            console.log("error while init subscription " + err);
        }

    }

    onBackMenu() {
        this.navCtrl.back();
        // (this.app.getRootNav() as NavController).pop();
    }

    distanceReached() {
        this.audioService.playAudio(GpsTracker.isBackground, true, this.option.applause);
        this.stop(false);
        if (!GpsTracker.isBackground) {
            console.log("s-7")
            this.invokeMenu();
        }
        this.strackerService.remove();
    }

    sendData(distance = null) {
        console.log('s=5.0');
        this.prepareRunStatisticsData().then((runStatistics) => {
            console.log('prepareRunStatisticsData: ' + JSON.stringify(runStatistics));
            console.log('s=5.1')
            if (navigator.onLine) {
                let d = (distance) ? parseInt(distance) : null;
                this.resultService.sendVirtualResults(runStatistics, d).then(async() => {
                    await this.storageService.create()
                    this.storageService._storage.remove('resultVirtual');
                    console.log('s=5.2')
                    this.openResults();
                }).catch((err) => console.log('error while sending data ' + err));
            } else {
                this.noConnectionSave(runStatistics);
            }
        });
    }

    async noConnectionSave(obj) {
        let loading = await this.loadingCtrl.create({
            message: this.translate.instant('NO_CONNECTION_SAVE'),
            duration: 10000
        });
        loading.present();

        window.addEventListener('online', () => {
            if (!this.dataSent) {
                this.resultService.sendVirtualResults(obj).then(async() => {
                    this.dataSent = true;
                    await this.storageService.create()
                    this.storageService._storage.remove('resultVirtual').then(() => {
                        loading.dismiss();
                        this.openResults(10000);
                    });
                });
            }
        });
    }

    async onConfigureModal() {
        const modal = await this.modalCtrl.create({component:TrackingSettingsPage, componentProps:{ option: this.option }});

        modal.onDidDismiss().then((options) => {
            this.updateSettings(options);
        });

        modal.present();
    }

    updateSettings(options) {
        console.log('updateSettings: ');
        this.option.applause = options.applause;
        this.option.autoPause = options.autoPause;
        this.option.placement = options.placement;

        this.storageService.saveData(options.applause, 'applause');
        this.storageService.saveData(options.autoPause, 'autopause');
        this.storageService.saveData(options.placement, 'placement');

        (options.placement) ? this.getLocater().setPlacement(true) : this.getLocater().removePlacement();

        AutoPause.getInstance().setEnabled(this.option.autoPause);

        if (this.option.autoPause) AutoPause.getInstance().run();
    }

    restartTrack() {

        this.sessionService.getToken().then(async () => {

            this.token = this.sessionService.profile.id + "";

            const actionSheet = await this.actionSheetCtrl.create({
                header: this.translate.instant('RESTART_ROUND'),
                buttons: [
                    {
                        text: this.translate.instant('GLOBAL_YES'),
                        role: 'destructive',
                        handler: () => {
                            if (this.getLocater().getCurrentDuration() == 0 && GpsTracker.sumDistance == 0) {
                                return;
                            }
                            this.strackerService.remove();
                            this.getLocater().clear();
                            this.clear();
                            this.stopTrack(false, true);
                            this.enableStopButton();

                            this.getLocater().setSubscriptions(this.reachedSub, this.reachedStartingPointSub);

                            this.actionPresented = false;
                            this.raceFinished = false;
                            GpsTracker.sumDistance = 0;

                            /*
                            UI function,
                            when the user clicks pause we hide the toolbar
                            if the auto pause is triggered we don't hide one
                            */
                            this.showheader = true;
                            this.hideheader = false;

                            if (typeof this.route != "undefined") {
                                if (this.route.hasRoute) {
                                    this.isPlayDisabled = true;
                                    this.warningMessage = true;
                                }
                            }

                            this.stepController.clear();
                        }
                    },
                    {
                        text: this.translate.instant('GLOBAL_NO'),
                        role: 'cancel',
                        handler: () => {
                            console.log('Cancel clicked');
                        }
                    }
                ]
            });
            actionSheet.present();
        });
    }

    clear() {
        this.view.average_speed = "0.0";
        this.view.average_pace = "0";

        this.runStatistics.reset();
        this.runStatistics.delete();

        this.allowCountdown = true;

        if (this.data) {
            this.data.average_pace = "0";
            this.data.average_speed = "0.0";
            this.data.distance = 0;
            this.data.finished = false;
            this.data.time = 0;
        }
    }

    getStarted() {
        return this.started;
    }

    prepareRunStatisticsData() {
        return new Promise<any>((resolve, reject) => {
            let encodedPath = "";
            try {
                encodedPath = google.maps.geometry.encoding.encodePath(this.runStatistics.routePoints);
            } catch (err) {
                console.log(err);
            }
            let encodedStatistics = encodeURI(JSON.stringify(this.runStatistics.kmStatistics));
            const totalAltitude = LocationHandlerUtil.calcAltitude(this.runStatistics.kmStatistics.map(x => x.elevation));

            let object = {
                cid: this.mode.id,
                eventId: this.event.id,
                timeSec: this.getDeepDuration(),
                routeStrn: encodedPath,
                detailSplitStrn: encodedStatistics,
                heightInMeterTotal: totalAltitude
            }

            let data = JSON.stringify(object);
            this.storageService.create().then(()=>{
                this.storageService._storage.set('resultVirtual', data).then(() => {
                    resolve(object);
                });
            })
        });
    }

    offlineMap: boolean = false;
    // loadMaps() {
    //     try {
    //         this.platform.ready().then(() => {
    //             var that = this;
    //             let loadMaps = setInterval(() => {
    //                 if (typeof google !== "undefined" && window.navigator.onLine) {

    //                     let mapConfig = {
    //                         zoom: 15,
    //                         center: { lat: 52.5204345, lng: 13.4014027 },
    //                         mapTypeId: google.maps.MapTypeId.TERRAIN,
    //                         disableDefaultUI: true
    //                     };

    //                     that.locater.setMap(new google.maps.Map(that.mapElement.nativeElement, mapConfig));

    //                     if (typeof this.route !== "undefined") {
    //                         if (this.route.hasRoute) {
    //                             console.log('this.route.hasRoute: ', this.route.hasRoute);
    //                             this.drawRoute();
    //                             this.isPlayDisabled = true;
    //                             this.warningMessage = true;
    //                             this.getLocater().hasRoute = true;
    //                             this.getLocater().startingPoint = this.route.fullPath[0];
    //                             this.getLocater().finishPoint = this.route.fullPath[this.route.fullPath.length - 1];
    //                         }
    //                     } else {
    //                         that.isPlayDisabled = false;
    //                     }

    //                     clearInterval(loadMaps);
    //                 }
    //             }, 400);
    //         });
    //     } catch (err) {
    //         console.log('loadMaps error = ' + err);
    //     }
    // }

    stepCountSub: any;

    startTrack() {
        console.log("started");
        console.log("token " + this.sessionService.getToken());

        this.sessionService.getToken().then(() => {
            console.log("section1");

            this.runStatistics.writeUserId(this.sessionService.profile.id);

            console.log("section2");

            this.token = this.sessionService.profile.id + "";

            console.log("section3");

            if (!this.started || !this.getLocater().stopWatch) {
                console.log("section4");
                if (this.allowCountdown) {
                    console.log("section5");
                    this.allowCountdown = false;
                    console.log("section6");
                    this.startConfigs();
                    // const modal = this.modalCtrl.create(CountdownComponent, { countdownBg: CountdownBg.FOREST });
                    // console.log("section7");

                    // modal.onDidDismiss(option => {
                    this.startConfigs();
                    //     console.log("section8");
                    // });
                    // console.log("section9");
                    // modal.present();
                } else {
                    console.log("section10");
                }
            }
        });
    }

    startConfigs() {
        try {
            this.started = true;
            this.showheader = false;
            this.hideheader = true;
            this.getLocater().startTrack((this.data) ? this.data.time : 0);
            if (!this.stepCountSub) this.runAccel();
            this.initPreload();
        } catch (err) {
            console.log('start track error = ' + err);
        }

        AutoPause.getInstance().setEnabled(this.option.autoPause);

        if (this.option.autoPause) AutoPause.getInstance().run();
    }

    runAccel() {
        console.log('runAccel: ');
        this.stepDetector.clear();

        try {
            this.stepCountSub = this.deviceMotion.watchAcceleration({ frequency: 100 }).subscribe((acceleration: DeviceMotionAccelerationData) => {
                let step = this.stepDetector.isAStep(acceleration.x, acceleration.y, acceleration.z);
                this.steps = this.stepDetector.stepCount;

                if (step) {
                    AutoPause.getInstance().setLastAction(new Date());
                    console.log('step: ' + step);
                    console.log('AutoPause.getInstance().isRunning(): ' + AutoPause.getInstance().isRunning());
                    console.log('this.started: ' + this.started);
                    console.log('this.getLocater().autoStartTrigger: ' + this.getLocater().autoStartTrigger);
                    if (!AutoPause.getInstance().isRunning() && !this.started && this.getLocater().autoStartTrigger) {
                        console.log('start-track')
                        this.startTrack();
                    }
                }
            });
        } catch (err) {
            console.log("Accel. Error = " + err);
        }
    }

    stopTrack(pause: boolean, restart: boolean = false) {
        AutoPause.getInstance().setRunning(false);

        if (this.started || this.getLocater().stopWatch) {
            this.data = null;
            this.getLocater().stopTrack();
            this.started = false;
            if (!restart) {
                console.log('saveStatistics from stop Track')
                this.runStatistics.updateMainRunStatistics().then(() => {
                    this.runStatistics.save();
                })
            }
        }

        if (pause) {
            if (this.stepCountSub) {
                this.stepCountSub.unsubscribe();
                this.stepCountSub = null;
            }
            this.getLocater().pluginTerminate();
        }
    }

    stop(pause: boolean) {
        this.showheader = true;
        this.hideheader = false;

        this.stopTrack(pause);
    }

    async fullStop(pause: boolean) {
        // if (this.started) {
        this.stop(pause);
        const actionSheet = await this.actionSheetCtrl.create({
            header: this.translate.instant('FULL_STOP_MESSAGE'),
            buttons: [
                {
                    text: this.translate.instant('GLOBAL_YES'),
                    role: 'destructive',
                    handler: () => {
                        this.raceFinished = true;
                        this.saveData(true);
                        this.strackerService.remove();
                        // this.sendData(GpsTracker.sumDistance);
                        this.disableStopButton();
                    }
                },
                {
                    text: this.translate.instant('GLOBAL_NO'),
                    role: 'cancel',
                    handler: () => {
                        this.startTrack();
                    }
                }
            ]
        });
        actionSheet.present();
        // }
    }

    disableStopButton() {
        this.strackerService.saveData(true, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = true;
        });
    }

    enableStopButton() {
        this.strackerService.saveData(false, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = false;
        });
    }

    isStopDisabled() {
        return (GpsTracker.sumDistance > 0) ? false : true;
    }

    getCurrentSpeed() {
        if (this.sessionService.isLoged) {
            let num = (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentSpeed() : "0";
            this.view.average_pace = num;
            return this.view.average_pace;
        } else {
            return "0:00";
        }
    }

    getDeepDuration() {
        return (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentDuration() : 0;
    }

    getCurrentDuration() {
        return StrackerUtils.transormSeconds(this.getDeepDuration());
    }

    getAverageSpeed() {
        if (this.sessionService.isLoged) {
            let sec = this.getDeepDuration();
            let dist = Number(this.getDeepDistance()); // already in km
            if (sec == 0) {
                return 0;
            }
            let result = dist / (sec / 3600);
            this.view.average_speed = isNaN(result) ? "0.0" : result.toFixed(1);
            return this.view.average_speed;
        } else {
            return "0.0";
        }
    }

    getDeepDistance() {
        if (this.sessionService.isLoged) {
            let d = (typeof this.locater !== "undefined") ? this.locater.getSumDistance() : 0;
            return (d / 1000).toFixed(2);
        } else {
            return "0.00";
        }
    }

    getLocater() {
        return this.locater;
    }
}


